<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.antecedents', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-row>
                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="type-group"
                                    :label="$t('message.select')+' '+$tc('message.types',1)"
                                    label-for="type">
                                <!-- Options -->
                                <select id="type"
                                        v-model="form.type"
                                        required
                                        class="form-control is-invalid retirerBordure"
                                        :state="$v.form.type.$dirty ? !(errorshasField('type') || $v.form.type.$error) : null"
                                        @focus="clearErrorField('type')"
                                >
                                    <option v-for="item in types" :value="item.value" :key="item.value">
                                        {{ item.text }}
                                    </option>
                                </select>

                                <b-form-invalid-feedback v-if="!$v.form.type.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('type')">
                                    {{ getErrorsField('type') }}
                                </b-form-invalid-feedback>

                            </b-form-group>

                        </b-col>

                    </b-row>
                    <b-row>
                        <b-col sm="12">

                            <b-form-group
                                    id="date-group"
                                    :label="$t('message.startDate')"
                                    label-for="date"
                            >
                                <b-form-input
                                        id="date"
                                        v-model="$v.form.date.$model"
                                        :state="$v.form.date.$dirty ? !$v.form.date.$error : null"
                                        type="date"
                                        required
                                        @click="clearErrorField('date')"
                                ></b-form-input>

                                <b-form-invalid-feedback>
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <span v-if="errorshasField('date')" style="color:red">
                                    {{getErrorsField('date')}}
                                    </span>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="description-group"
                                    :label="$t('message.description')"
                                    label-for="description"
                            >
                                <b-form-textarea
                                        id="description"
                                        v-model="$v.form.description.$model"
                                        :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                        required
                                        @focus="errorshasField('description')"
                                ></b-form-textarea>

                                <b-form-invalid-feedback v-if="!$v.form.description.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-if="!$v.form.description.minLength">
                                    {{ $t('message.minCharacters', { n: 3 }) }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                    {{ getErrorsField('description') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                    </b-row>

                    <b-row class="justify-content-sm-center" v-if="form.isAuthor || hasMedecinControleRole || hasAdminRole || hasAssistante">
                        <b-button @click="onSubmit" variant="primary">
                            {{ $t('message.edit') }}
                        </b-button>

<!--                        <b-button type="reset" variant="danger">-->
<!--                            {{ $t('message.reset') }}-->
<!--                        </b-button>-->
                    </b-row>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, minLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';

    export default {
        name: "EditAntecedent",

        computed: {
            ...mapGetters(["antecedent", "files", "errors", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            form: function() {
                return this.antecedent;
            },

            info:function(){
                if(typeof this.form.dossier == 'object')
                {
                    let dossier = this.form.dossier;
                    return dossier.numero_dossier;
                }

                return  "";
            },

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            }
        },

        data() {
            return {
                antecedent_id: this.$route.params.antecedent,
                show: true,
                types: [
                    { value: 'Médical', text: 'Médical' },
                    { value: 'Chirugical', text: 'Chirugical' },
                    { value: 'Gynéco-obstétrique', text: 'Gynéco-obstétrique' },
                    { value: 'Familial', text: 'Familial' }
                ],
            }
        },

        methods: {
            getAntecedent: function() {
                let args = {
                    antecedent: this.antecedent_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getAntecedent', { args, errorMessages });
            },

            getMedicalFiles: function() {
                let args = {};

                this.$store.dispatch('getMedicalFiles', { args });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        antecedent: this.antecedent_id,
                        dossier_medical_id: this.form.dossier_medical_id,
                        type: this.form.type,
                        date: this.form.date,
                        description: this.form.description
                    };

                    let successMessage = this.$i18n.t('message.antecedentUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateAntecedent', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.dossier_medical_id = '';
                this.form.type = '';
                this.form.description = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                // dossier_medical_id: {
                //     required
                // },
                type: {
                    required
                },
                description: {
                    required,
                    minLength:minLength(3)
                },
                date: {
                    //
                }
            }
        },

        mounted() {
            // Retrieve antecedent
            this.getAntecedent();

            // Retrieve medical file list
            // this.getMedicalFiles();
            // new SlimSelect({
            //     select: '#single',
            //     placeholder: 'Select your country'
            // });
            new SlimSelect({
                select: '#type',
                placeholder: 'Select type'
            });

        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>